<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <v-toolbar style="margin-bottom: 10px; margin-left: 3px; margin-top: 10px;
          border-radius: 10px; padding-top: 40px; padding-bottom: 20px; height: fit-content;">
      <v-container>
        <v-row>
          <v-toolbar-title style="color: #4a4a4a; margin-top: 0; margin-bottom: 10px;">{{ $t('dashboardTrips.title')
            }}</v-toolbar-title>
        </v-row>
        <v-form ref="form" v-model="formValidado">
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete v-model="idEmpresaSelected" :items="empresas" item-text="razao_social"
                item-value="id_empresa" clearable :label="$t('dashboardTrips.company')"
                @change="onEmpresaSelectChanged"></v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" sm="4" md="3">
                <v-datetime-picker
                  label="Data Inicial"
                  v-model="dtinicial"
                  :time-picker-props="timeProps"
                  :text-field-props="textFieldProps"
                  time-format="HH:mm:ss"
                  date-format="dd/MM/yyyy"
                  clear-text="Fechar"
                  @input="onDateChanged"
                >
                  <template slot="dateIcon">
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                  <template slot="timeIcon">
                    <v-icon>mdi-clock</v-icon>
                  </template>
                </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-datetime-picker
                label="Data Final"
                v-model="dtfinal"
                :time-picker-props="timeProps"
                :text-field-props="textFieldProps"
                time-format="HH:mm:ss"
                date-format="dd/MM/yyyy"
                clear-text="Fechar"
                @input="onDateChanged"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="6" md="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    fab
                    color="primary darken-1"
                    class="white--text"
                    v-bind="attrs"
                    v-on="on"
                    @click="populaRelatorio"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('dashboardTrips.search') }}</span>
              </v-tooltip>
            </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  v-model="idLinhaSelected"
                  :items="linhasSelect"
                  item-text="nome_linha"
                  item-value="id_linha"
                  clearable
                  :label="$t('dashboardTrips.line')"
                  @change="linhasSelectChanged"
                  :disabled="isLinhaSelectDisabled"
                  :rules="[veiculoGuiaLinhaRules]"
                ></v-autocomplete>
              </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="idVeiculoSelected"
                :items="veiculosSelect"
                item-text="numero_ordem"
                item-value="id_veiculo"
                clearable
                multiple
                :label="$t('dashboardTrips.vehicle')"
                @change="veiculosSelectChanged"
                :disabled="isVeiculoSelectDisabled"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="idGuiaSelected"
                :items="guiasSelect"
                item-text="descricao_curta"
                item-value="id_guia"
                clearable
                :label="$t('dashboardTrips.guide')"
                @change="guiasSelectChanged"
              ></v-autocomplete>
            </v-col> -->
          </v-row>
        </v-form>
      </v-container>
    </v-toolbar>

      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h3>Por Empresa</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <merus-data-table
              :headers="headersTotalWithProperties"
              :items="agregadoTotalFiltered"
              class="elevation-7"
              locale="pt"
              sort-by="id_empresa"
              :loading="loadingTotal"
              :loading-text="$t('dashboardTrips.loadingTripsByCompany')"
              style="border-radius: 10px; margin-bottom: 10px;"
              @update:displayedItems="displayedCompanyItemsForExport = $event"
          >
              <template v-slot:toolbar>
                  <CadastroToolbar
                      :title="$t('dashboardTrips.tripsByCompany')"
                      :token="token"
                      :items="displayedCompanyItemsForExport !== null ? displayedCompanyItemsForExport : agregadoTotalFiltered"
                      csv-title="agregadoviagenstotal"
                      :pdf-title="$t('dashboardTrips.tripsByCompany')"
                      :pdf-headers="headersTotal"
                      :pdf-subtitle="pdfsubtitle"
                      pdf-filename="agregadoviagenstotal"
                      hide-search
                  />
              </template>

            <template v-slot:item.porcentagem_partidas="{ item }">
              <PercentItem :value="item.porcentagem_partidas"></PercentItem>
            </template>

            <template v-slot:item.porcentagem_pontuais="{ item }">
              <PercentItem :value="item.porcentagem_pontuais"></PercentItem>
            </template>

            <template v-slot:item.porcentagem_atrasadas="{ item }">
              <PercentItem :value="item.porcentagem_atrasadas"></PercentItem>
            </template>

            <template v-slot:item.porcentagem_adiantadas="{ item }">
              <PercentItem :value="item.porcentagem_adiantadas"></PercentItem>
            </template>

            <template v-slot:item.porcentagem_extras="{ item }">
              <PercentItem :value="item.porcentagem_extras"></PercentItem>
            </template>

              <template v-slot:item.porcentagem_realizadas="{ item }">
                  <PercentItem :value="item.porcentagem_realizadas"></PercentItem>
              </template>
              
          </merus-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h3>{{ $t('dashboardTrips.byLine') }}</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <merus-data-table
              :headers="headersLinhasWithProperties"
              :items="agregadoLinhasFiltered"
              sort-by="id_linha"
              class="elevation-7"
              locale="pt"
              :loading="loadingLinhas"
              :loading-text="$t('dashboardTrips.loadingTripsByLine')"
              style="border-radius: 10px; margin-bottom: 10px;"
              @update:displayedItems="displayedLineItemsForExport = $event"
          >
              <template v-slot:toolbar>
                  <CadastroToolbar
                      :title="$t('dashboardTrips.tripsByLine')"
                      :token="token"
                      :items="displayedLineItemsForExport !== null ? displayedLineItemsForExport : agregadoLinhasFiltered"
                      csv-title="agregadoviagens"
                      :pdf-title="$t('dashboardTrips.tripsByLine')"
                      :pdf-headers="headersLinhas"
                      :pdf-subtitle="pdfsubtitle"
                      pdf-filename="agregadoviagens"
                      hide-search
                  />
              </template>

            <template v-slot:item.porcentagem_partidas="{ item }">
              <PercentItem :value="item.porcentagem_partidas"></PercentItem>
            </template>

            <template v-slot:item.porcentagem_pontuais="{ item }">
              <PercentItem :value="item.porcentagem_pontuais"></PercentItem>
            </template>

            <template v-slot:item.porcentagem_atrasadas="{ item }">
              <PercentItem :value="item.porcentagem_atrasadas"></PercentItem>
            </template>

            <template v-slot:item.porcentagem_adiantadas="{ item }">
              <PercentItem :value="item.porcentagem_adiantadas"></PercentItem>
            </template>

            <template v-slot:item.porcentagem_extras="{ item }">
              <PercentItem :value="item.porcentagem_extras"></PercentItem>
            </template>

              <template v-slot:item.porcentagem_realizadas="{ item }">
                  <PercentItem :value="item.porcentagem_realizadas"></PercentItem>
              </template>
              
          </merus-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </template>
  
  <script>
  import apiController from "@/utils/apiController";
  import EventBus from "@/utils/eventBus";
  import DateUtils from "../utils/dateutils";
  import PercentItem from "./PercentItem.vue";
  import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
  import MerusDataTable from './Tables/MerusDataTable.vue';
  
  export default {
    components: {
    PercentItem,
    CadastroToolbar,
    MerusDataTable,
},
    data: () => ({
      user: null,
      token: null,
      showConfirmButton: true,
      messageConfirmButton: "Sim",
      messageDismissButton: "Não",
      formValidado: false,
      displayedCompanyItemsForExport: null,
      displayedLineItemsForExport: null,
      loadingLinhas: false,
      loadingTotal: false,
      config: null,
      dti: null,
      dtf: null,
      idEmpresaSelected:  null,
      idLinhaSelected: null,
      empresas: [],
      linhasSelect: [],
      agregadoLinhas: [],
      agregadoLinhasFiltered: [],
      agregadoTotal: [],
      agregadoTotalFiltered: [],
      recursos: [],
      empresasPermitidas: [],
    }),
    computed: {
      pdfsubtitle() {
        return "";
      },
      headersLinhas() {
      return [
        { text: this.$t('dashboardTrips.headers.idLine'), value: "id_linha", align: " d-none" },
        { text: this.$t('dashboardTrips.headers.line'), value: "cod_linha", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentDepartures'), value: "porcentagem_partidas", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentOnTime'), value: "porcentagem_pontuais", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentDelayed'), value: "porcentagem_atrasadas", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentEarly'), value: "porcentagem_adiantadas", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentUnassociated'), value: "porcentagem_extras", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentCompleted'), value: "porcentagem_realizadas", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.planned'), value: "previstas", align: "center" },
        { text: this.$t('dashboardTrips.headers.departures'), value: "partidas", align: "center" },
        { text: this.$t('dashboardTrips.headers.onTime'), value: "pontuais", align: "center" },
        { text: this.$t('dashboardTrips.headers.delayed'), value: "atrasadas", align: "center" },
        { text: this.$t('dashboardTrips.headers.early'), value: "adiantadas", align: "center" },
        { text: this.$t('dashboardTrips.headers.unassociated'), value: "extras", align: "center" },
        { text: this.$t('dashboardTrips.headers.completed'), value: "realizadas", align: "center" }]
    },
    headersTotal() {
      return [
        { text: this.$t('dashboardTrips.headers.idCompany'), value: "id_empresa", align: " d-none" },
        { text: this.$t('dashboardTrips.headers.company'), value: "razao_social", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.planned'), value: "previstas", align: "center" },
        { text: this.$t('dashboardTrips.headers.departures'), value: "partidas", align: "center" },
        { text: this.$t('dashboardTrips.headers.onTime'), value: "pontuais", align: "center" },
        { text: this.$t('dashboardTrips.headers.delayed'), value: "atrasadas", align: "center" },
        { text: this.$t('dashboardTrips.headers.early'), value: "adiantadas", align: "center" },
        { text: this.$t('dashboardTrips.headers.unassociated'), value: "extras", align: "center" },
        { text: this.$t('dashboardTrips.headers.completed'), value: "realizadas", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentDepartures'), value: "porcentagem_partidas", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentOnTime'), value: "porcentagem_pontuais", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentDelayed'), value: "porcentagem_atrasadas", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentEarly'), value: "porcentagem_adiantadas", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentUnassociated'), value: "porcentagem_extras", width: "10%", align: "center" },
        { text: this.$t('dashboardTrips.headers.percentCompleted'), value: "porcentagem_realizadas", width: "10%", align: "center" }]
    },
    messageConfirmButton() {
      return this.$t('button.confirm');
    },
    messageDismissButton() {
      return this.$t('button.dismiss');
    },
      headersTotalWithProperties() {
        return this.headersTotal.map(header => ({
          ...header,
          filtrable: true,
          sortable: true
        }));
      },
      headersLinhasWithProperties() {
        return this.headersLinhas.map(header => ({
          ...header,
          filtrable: true,
          sortable: true
        }));
      },
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
      }
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initialize();
    },
    mounted() {},
    methods: {
      initialize() {
        this.populaRecursos();
      },
      populaRecursos() {
        if (this.user.is_superadmin === 1) {
          apiController.request(apiController.endpoints.getallRecursos, {
            silent: true,
            onSuccess: (response) => {
              this.recursos = response.data;
              this.populaEmpresasPermitidas();
              this.populaEmpresas();
              this.populaConfig();
            },
            onError: (e) => {
              console.log("Response : " + e.message);
              if (e.message == "Request failed with status code 401") {
                EventBus.$emit('show-error', { error: e });
              }
            },
          });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          silent: true,
          onSuccess: (response) => {
            this.recursos = response.data;
            this.populaEmpresasPermitidas();
            this.populaEmpresas();
            this.populaConfig();
          },
          onError: (e) => {
            console.log("Response : " + e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog = e.response.data.mensagem;
              this.autorizacaoDialog = true;
            }
          },
        });
      }
    },
    populaEmpresasPermitidas() {
      this.empresasPermitidas = this.recursos.filter((r) => r.id_empresa).map((rec) => {
        return rec.id_empresa
      });
    },
    populaConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        silent: true,
        onSuccess: (response) => {
          this.config = response.data[0];
          this.populaDashboard();
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    },
    populaDashboard() {
      this.loadingLinhas = true;
      this.loadingTotal = true;
      let today = new Date();
      let date = DateUtils.getDateSQLFormatted(today);
      this.dtf = date;
      if (date.substring(8) >= this.config.hora_inicial_dia_operacao.replace(":", "") + "00") {
        this.dti = date.substring(0, 8) + this.config.hora_inicial_dia_operacao.replace(":", "") + "00"
      } else {
        today.setDate(today.getDate() - 1)
        this.dti = DateUtils.getDateSQLFormatted(today).substring(0, 8) + this.config.hora_inicial_dia_operacao.replace(":", "") + "00"
      }

      this.populaDadosLinhas();
      this.populaDadosTotais();
      setTimeout(() => this.populaDashboard(), 30000);
    },
    populaDadosTotais() {
      apiController.request(apiController.endpoints.getAgregadosviagens, {
        params: {
          atraso: this.config.atraso_minimo_viagens_previstas,
          adiantamento: this.config.limite_adiantamento_viagem_prevista,
          dti: this.dti,
          dtf: this.dtf,
        },
        silent: true,
        onSuccess: (response) => {
          this.agregadoTotal = response.data.filter((a) => this.empresasPermitidas.includes(a.id_empresa));
          this.onEmpresaSelectChanged();
          this.loadingTotal = false;
        },
        onError: (e) => {
          this.loadingTotal = false;
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    },
    populaDadosLinhas() {
      apiController.request(apiController.endpoints.getAgregadosviagenslinhas, {
        params: {
          atraso: this.config.atraso_minimo_viagens_previstas,
          adiantamento: this.config.limite_adiantamento_viagem_prevista,
          dti: this.dti,
          dtf: this.dtf,
        },
        silent: true,
        onSuccess: (response) => {
          this.agregadoLinhas = response.data.filter((a) => this.empresasPermitidas.includes(a.id_empresa));
          this.onEmpresaSelectChanged();
          this.loadingLinhas = false;
        },
        onError: (e) => {
          this.loadingLinhas = false;
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        silent: true,
        onSuccess: (response) => {
          this.empresas = response.data.filter((e) => this.empresasPermitidas.includes(e.id_empresa));
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    },
    onEmpresaSelectChanged() {
      if (this.idEmpresaSelected) {
        this.agregadoLinhasFiltered = this.agregadoLinhas.filter((a) => a.id_empresa === this.idEmpresaSelected);
        this.agregadoTotalFiltered = this.agregadoTotal.filter((a) => a.id_empresa === this.idEmpresaSelected);
      } else {
        this.agregadoLinhasFiltered = this.agregadoLinhas;
        this.agregadoTotalFiltered = this.agregadoTotal;
      }
    },
  },
};
</script>